import i18n from '@/i18n';
import store from '@/store';

export default {
    data: function () {
        return {
            serverErrors: {}
        }
    },
    methods: {
        hasServerError(field) {
            return _.has(this.serverErrors, field);
        },

        getServerErrors(field) {
            return [].concat(_.get(this.serverErrors, field, []));
        },

        getValidationClass(fieldName, form) {
            const field = _.get(form || this.$v.form, fieldName);

            if (field) {
                return {
                    'md-invalid': (field.$invalid && field.$dirty) || this.hasServerError(fieldName)
                }
            }

            if (this.hasServerError(fieldName)) {
                return {
                    'md-invalid': true
                }
            }
        },

        handleServerValidationError(error) {
            if (error.response.status === 400 && !error.handled) {
                const errorMessageCode = _.get(error.response, 'data.data.errorMessageCode');

                if (errorMessageCode && errorMessageCode === 'VALIDATION_EXCEPTION') {
                    this.serverErrors = _.get(error.response, 'data.data.params', []);
                    return;
                } else {
                    if (i18n.te(`error.code.${errorMessageCode}`)) {
                        store.commit('snackbar/SNACKBAR_TITLE', i18n.t(`error.code.${errorMessageCode}`));
                        store.commit('snackbar/SNACKBAR_SHOW', true);
                        return;
                    } else {
                        store.commit('snackbar/SNACKBAR_TITLE', i18n.t(`error.status.${error.response.status}`));
                        store.commit('snackbar/SNACKBAR_SHOW', true);
                        return;
                    }
                }
            }

            return Promise.reject(error);
        }
    }
}
